var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Filter",
                    "label-for": "filter-input",
                    "label-cols-sm": "2",
                    "label-size": "sm",
                  },
                },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filter-input",
                          type: "search",
                          placeholder: "Type to Search",
                          size: "sm",
                        },
                        model: {
                          value: _vm.filter,
                          callback: function ($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                staticClass: "mt-3",
                attrs: {
                  id: "table_permission",
                  fields: _vm.fields,
                  items: _vm.permissions,
                  outlined: "",
                  responsive: "",
                  hover: "",
                  small: true,
                  "per-page": _vm.perPage,
                  "sticky-header": true,
                  "current-page": _vm.currentViewPage,
                  filter: _vm.filter,
                  "show-empty": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.permissions && _vm.permissions.length > _vm.perPage
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      "total-rows":
                        (_vm.permissions && _vm.permissions.length) || 0,
                      "per-page": _vm.perPage,
                      "aria-controls": "table_permission",
                      size: "sm",
                      align: "center",
                    },
                    model: {
                      value: _vm.currentViewPage,
                      callback: function ($$v) {
                        _vm.currentViewPage = $$v
                      },
                      expression: "currentViewPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }